import { render } from "./ClientUsers.vue?vue&type=template&id=27647d9a&ts=true"
import script from "./ClientUsers.vue?vue&type=script&lang=ts"
export * from "./ClientUsers.vue?vue&type=script&lang=ts"

import "./ClientUsers.vue?vue&type=style&index=0&id=27647d9a&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__